export const CompanyErrorTopic = "MEMBER_DELETE";
